
<p class="call font-roboto flex items-center justify-center gap-4">Have a question? Call
  <img src="@/images/quote-builder/phone.svg" alt="Give as a call">
  <a :href="`tel:${organization.phone}`">
    {{ formatPhoneNumber(organization.phone) }}
  </a>
</p>
